import type { Membership } from "../types/models";
import { fetchIdentityGroupMemberships } from "./identityGroups";

export async function fetchMemberships(identityId: string, max = 100): Promise<Membership[]> {
  if (!identityId) return [];
  const items = await fetchIdentityGroupMemberships(identityId, max);
  return items.map((item) => ({
    groupId: item.groupId,
    groupName: item.groupName,
    role: item.role,
    isPublic: item.isPublic,
    joinedAt: item.joinedAt,
    updatedAt: item.updatedAt,
  }));
}
